/**
 * Imperative one-shot DOM animations (floating reaction emojis, double-tap
 * heart burst). Kept out of the render tree because they are transient and
 * self-cleaning - cheaper than reconciling dozens of throwaway nodes.
 */

/** Spawn a small shower of `emoji` rising from the centre of `container`. */
export function spawnFloatingEmojis(container, emoji, count = 5) {
  if (!container) return;
  for (let i = 0; i < count; i++) {
    const el = document.createElement('div');
    el.className = 'fx-emoji';
    el.textContent = emoji;
    const duration = 1.5 + Math.random() * 0.5;
    const delay = Math.random() * 0.3;
    el.style.setProperty('--x', `${(Math.random() - 0.5) * 100}vw`);
    el.style.setProperty('--y', `${(Math.random() - 0.5) * 50}vh`);
    el.style.setProperty('--delay', `${delay}s`);
    el.style.setProperty('--duration', `${duration}s`);
    el.style.setProperty('--scale', `${1 + Math.random() * 0.5}`);
    el.style.setProperty('--rotation', `${(Math.random() - 0.5) * 60}deg`);
    container.appendChild(el);
    window.setTimeout(
      () => container.contains(el) && container.removeChild(el),
      (duration + delay) * 1000 + 100,
    );
  }
}

/** Pop a big heart at viewport coordinates (double-tap to like). */
export function spawnHeartBurst(container, x, y) {
  if (!container) return;
  const el = document.createElement('div');
  el.className = 'fx-heart';
  el.textContent = '❤️';
  el.style.left = `${x}px`;
  el.style.top = `${y}px`;
  el.style.setProperty('--tilt', `${(Math.random() - 0.5) * 30}deg`);
  container.appendChild(el);
  window.setTimeout(
    () => container.contains(el) && container.removeChild(el),
    900,
  );
}
